export const MEDIA_ORIENTATIONS = {
  PORTRAIT: 'portrait',
  LANDSCAPE: 'landscape',
} as const;

export type MediaOrientation =
  (typeof MEDIA_ORIENTATIONS)[keyof typeof MEDIA_ORIENTATIONS];
